import { IGroupPermissionCreate, IRequest } from "@/models";

import { BaseRepository } from "@/repositories";

class GroupPermissionRepository extends BaseRepository<IRequest | IGroupPermissionCreate> {
    protected getAllErrorMessage = "Requests cannot be retrieved.";

    protected getOneErrorMessage = "Request cannot be retrieved.";

    protected addErrorMessage = "Request cannot be created or validated/removed, please verify fields.";

    protected replaceErrorMessage = "Request files cannot be added to your request(s).";

    constructor() {
        super("/group/permissions");
    }

    public async updateRequestFiles(appCode: string, requestIds: number[], files: File[]): Promise<IRequest[]> {
        const formData = new FormData();
        requestIds.forEach((requestId, index) => formData.append(`requestIds[${index}]`, requestId.toString()));
        files.forEach((file, index) => formData.append(`files[${index}]`, file));

        return await this.replace(formData, `/${appCode}`, "multipart/form-data") as IRequest[];
    }
}

const groupPermissionRepository = new GroupPermissionRepository();

export { GroupPermissionRepository, groupPermissionRepository };
